import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1fdce465"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-targ" }
const _hoisted_2 = { class: "select-targ-item" }
const _hoisted_3 = { class: "select-dprodown-box" }

import {
  ref,
  Teleport,
  CSSProperties,
  provide,
  reactive,
  watchEffect,
  nextTick,
  watch,
  VNode,
} from 'vue';
import type { SelectValue } from 'ant-design-vue/lib/select';
import type { StyleValue } from 'vue';
import domAlign from 'dom-align';
import { PreTransition } from '@/components';
import { ArrowDown } from '@/components/icons';
export type SelectStore = {
  value?: string;
  label?: string;
  visable?: boolean;
  icon?: VNode | null;
};
export type SelectProps = {
  value?: SelectValue;
  width?: number;
  dropdownWidth?: number;
  style?: StyleValue;
  showAllow?: boolean;
  dropdownStyle?: StyleValue;
  disabled?: boolean;
  showIcon?: boolean;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'select',
  props: {
    value: {},
    width: {},
    dropdownWidth: {},
    style: { default: {} as any },
    showAllow: { type: Boolean, default: true },
    dropdownStyle: {},
    disabled: { type: Boolean, default: false },
    showIcon: { type: Boolean }
  },
  emits: ["update:value", "change"],
  setup(__props: any, { emit }) {

const props = __props;

/*
 * @author: Lew
 * @e-mail: yaol@jiguang.cn
 * @date: 2022/08/22 14:17:30
 * @description: 下拉组件
 */



const div = document.createElement('div');
div.style.position = 'absolute';
div.style.top = '0';
div.style.left = '0';
div.style.width = '100%';
div.style.zIndex = '2147483502';
const ticking = ref<boolean>(false);
const sourceWidth = ref<number>(0);
const targetWidth = ref<number>(0);
const target = ref<Element>();
const source = ref<Element>();
const selectStore = reactive<SelectStore>({
  value: '',
  label: '',
  icon: undefined,
  visable: false,
});
provide('selectStore', selectStore);

const handleTrigger = () => {
  if (props.disabled) return;
  selectStore.visable = !selectStore.visable;
  if (!document.body.contains(div)) document.body.append(div);
  if (selectStore.visable) {
    nextTick(() => {
      sourceWidth.value = Number(source.value?.clientWidth);
      targetWidth.value = Number(target.value?.clientWidth);
      domAlign(source.value, target.value, {
        points: ['tl', 'bl'],
        overflow: { adjustX: true, adjustY: true },
      });
    });
  }
};

const documentClick = (event: Event) => {
  if (target.value?.contains(event.target as Node)) return;
  selectStore.visable = Boolean(source.value?.contains(event.target as Node));
};

watchEffect(() => {
  selectStore.value = String(props.value);
});

watch(
  () => selectStore.value,
  (value = '') => {
    emit('update:value', value);
    emit('change', value);
  },
);

watchEffect(() => {
  if (selectStore.visable) document.addEventListener('click', documentClick);
  else document.removeEventListener('click', documentClick);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      ref_key: "target",
      ref: target,
      class: _normalizeClass(['select', selectStore.visable && 'select--active']),
      style: _normalizeStyle((Object.assign(_ctx.style as StyleValue, _ctx.width && { width: `${_ctx.width}px` }) as CSSProperties)),
      onClick: handleTrigger
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(['select-selector', _ctx.disabled && 'disabled'])
      }, [
        _createElementVNode("main", _hoisted_1, [
          (selectStore.icon && _ctx.showIcon)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(selectStore.icon), { key: 0 }))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_2, _toDisplayString(selectStore.label), 1)
        ]),
        (_ctx.showAllow)
          ? (_openBlock(), _createBlock(_unref(ArrowDown), {
              key: 0,
              class: "select-arrow"
            }))
          : _createCommentVNode("", true)
      ], 2)
    ], 6),
    (_openBlock(), _createBlock(_Teleport, { to: _unref(div) }, [
      _createElementVNode("div", {
        ref_key: "source",
        ref: source,
        class: "select-dropdown",
        style: _normalizeStyle({
        minWidth: `${Math.max(targetWidth.value, Number(_ctx.width ?? 0))}px`,
        width: `${_ctx.dropdownWidth}px`,
      }),
        onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (ticking.value = false)),
        onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (ticking.value = true))
      }, [
        _createVNode(_unref(PreTransition), { type: "shrink" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("ul", _hoisted_3, [
              _renderSlot(_ctx.$slots, "search"),
              _createElementVNode("section", {
                class: "select-dropdown-item",
                style: _normalizeStyle(_ctx.dropdownStyle)
              }, [
                _renderSlot(_ctx.$slots, "default")
              ], 4)
            ], 512), [
              [_vShow, selectStore.visable]
            ])
          ]),
          _: 3
        })
      ], 36)
    ], 8, ["to"]))
  ], 64))
}
}

})